<div class="row">
    <div class="col-16">
        <p class="bottom-10">
            Some individuals may have other drug coverage, including other private insurance, TRICARE, Federal employee health benefits coverage, VA benefits, or State Pharmaceutical Assistance Programs.
        </p>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="input-wrapper bottom-10">
            <label>Will you have other prescription drug coverage in addition to {{orgName}} Prescription Drug Plan?</label>
            <ValidatedRadioButtonGroup [label]=""
                                       [options]="optionrbPresDrug"
                                       [selectedValue]="enrollment.OTHCVRG"
                                       (onValueChange)="toggle($event,'OTHCVRG')"
                                       [radioGroupName]="'Secondary-Coverage'">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>
<div *ngIf="showDet || showOtherCoverage">
    <fieldset>
        <legend>If “yes,” please list your other coverage and your identification (ID) number(s) for this coverage:</legend>

        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <ValidatedTextField [label]="'Name of other coverage'"
                                        [text]="enrollment.OTHCVRGNAME"
                                        [disabled]="disabled"
                                        (onValueChange)="updateInfo('OTHCVRGNAME',$event)">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <ValidatedTextField [label]="'ID# for this coverage (optional)'"
                                        [text]="enrollment.OTHCVRGID"
                                        [disabled]="disabled"
                                        (onValueChange)="updateInfo('OTHCVRGID',$event)">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <ValidatedTextField [label]="'Group # for this coverage (optional)'"
                                        [text]="enrollment.OTHCVRGGRP"
                                        [disabled]="disabled"
                                        (onValueChange)="updateInfo('OTHCVRGGRP',$event)">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <ValidatedTextField [label]="'RxBIN for this coverage (optional)'"
                                        [text]="enrollment.COBBIN"
                                        [disabled]="disabled"
                                        (onValueChange)="updateInfo('COBBIN',$event)">
                    </ValidatedTextField>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <ValidatedTextField [label]="'RxPCN for this coverage (optional)'"
                                        [text]="enrollment.COBPCN"
                                        [disabled]="disabled"
                                        (onValueChange)="updateInfo('COBPCN',$event)">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <label>Effective Date for this coverage (optional)</label>
                    <JQDatePicker [selectedDate]="enrollment.COBEFFDT"
                                  (elementClicked)="updateInfo('COBEFFDT',$event)">
                    </JQDatePicker>
                    <!--<ValidatedDateTextField label="Effective Date for this coverage"
                                            [date]="enrollment.COBEFFDT"
                                            (onDateChange)="updateInfo('COBEFFDT',$event)"
                                            [validators]="[dateTextFieldValidator]"
                                            [disabled]="disabled">
                    </ValidatedDateTextField>-->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <label>Termination Date for this coverage (optional)</label>
                    <JQDatePicker [selectedDate]="enrollment.COBTERMDT"
                                  (elementClicked)="updateInfo('COBTERMDT',$event)">
                    </JQDatePicker>
                    <!--<ValidatedDateTextField label="Termination Date for this coverage"
                                            [date]="enrollment.COBTERMDT"
                                            (onDateChange)="updateInfo('COBTERMDT',$event)"
                                            [validators]="[dateTextFieldValidator]"
                                            [disabled]="disabled">
                    </ValidatedDateTextField>-->
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="row" *ngIf="visibleFrom2026 && !isExternalAgentEnrl">
    <div class="col-22">
                <div class="input-wrapper bottom-10">
                <label>
                    Is the enrollee a current or past Aetna Medicare Prescription Drug Plan (PDP) member?<br />
                    If “Yes,” write in Aetna Member ID number (9 digits):
                </label>
                <div class="textbox">
                    <ValidatedTextField class="" [label]=""
                                        [text]="enrollment.PRIORID"
                                        [disabled]="disabled"
                                        [maxlength]="12"
                                        (onValueChange)="updateInfo('PRIORID',$event)">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="visibleFrom2025">
        <div class="col-22">
            <genderPref [enrollmentgenderPrefyViewModel]="enrollment"></genderPref>
        </div>
    </div>
    <div class="row" *ngIf="!enrollment.ISSINGLEGROUP && !visibleFrom2026">
        <raceethnicity [enrollmentRaceEthnicityViewModel]="enrollment"></raceethnicity>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper bottom-10">
                <ValidatedRadioButtonGroup [label]="'Applicant prefers to receive written communications in:'"
                                           [options]="optionrbLang"
                                           [selectedValue]="enrollment.LANG"
                                           (onValueChange)="enrollment.LANG =$event"
                                           [radioGroupName]="'Lang'">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>
    <!--<div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    If you need information in an alternate language or accessible format, such as Braille, audio tape or large print, please contact {{orgName}} at <a class="tel-no" href="tel:+18557719286">1-855-771-9286,</a> 24 hours a day, 7 days a week. (TTY users call <a class="tel-no" href="tel:+711">711</a>).
                </p>
            </div>
        </div>
    </div>-->
